import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";
import { FiSearch, FiLayers, FiFeather } from "react-icons/fi";
import React from "react";
const steps = [
  {
    icon: <FiSearch size={32} color="#ff5670" />,
    title: "제품분석",
    desc: [
      "색채 선정을 위한 시장조사",
      "기존 제품 특징 및 색채영역분석",
      "트렌드컬러/타겟컬러 분석",
      "제품색 테스트, 피드백, 문제점 파악",
    ],
  },
  {
    icon: <FiLayers size={32} color="#ff5670" />,
    title: "색채기획",
    desc: [
        "색채 컨셉과 팔레트 범위 선정",
        "컬러 마케팅 전략 수립",
        "출시제품 컬러팔레트 선정 및 개발",
      ],
  },
  {
    icon: <FiFeather size={32} color="#ff5670" />,
    title: "색채디자인",
    desc: [
        "브랜드 스토리에 맞는 색채 디자인 선정",
        "기존 제품 컬러 리뉴얼 작업",
        "향후 컬러 조합, 뉴컬러 구성안 제안",
        "제품 특징에 맞는 컬러팔레트 적용",
      ],
  },
];
function EnterpriseProduct() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-02.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>제품 컬러 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                제품 색채디자인은,
                <br />
                브랜드를 위한 커스터마이징 컬러 컨설팅을 통해 정체성과 제품
                개발에 맞는 컬러 팔레트를 제안합니다
              </div>
              <ul className={styles.infoList}>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    브랜드의 제품, 서비스에 담긴 스토리 및 비전을 효과적으로
                    전달 할 수 있도록 도움
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    소비자가 긍정적 인상을 가질 수 있도록 컬러 트렌드를 반영하되
                    브랜드 컬러의 일관성 보장
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.steps}>
            {steps.map((step, i) => (
              <React.Fragment key={i}>
                <div className={styles.step}>
                  <div className={styles.iconWrap}>{step.icon}</div>
                  <div className={styles.textWrap}>
                    <div className={styles.stepTitle}>{step.title}</div>
                    <div className={styles.stepDesc}>
                      <div className={styles.stepDesc}>
                        {Array.isArray(step.desc) ? (
                          <ul>
                            {step.desc.map((text, idx) => (
                              <li key={idx}>{text}</li>
                            ))}
                          </ul>
                        ) : (
                          step.desc
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {i < steps.length - 1 && (
                  <div className={styles.arrowWrap}>
                    <img
                      src="/image/arrow_right.png"
                      alt="arrow_right"
                      className={styles.arrow}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default EnterpriseProduct;
